/**
 * Numeri e date della mappa delle aziende nella lingua di chi guarda: le funzioni del gestionale
 * (`core/i18n/formattazione.ts`), mai `toLocaleString` scritto a mano.
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { creaContestoLocale } from '@gestionale/core/i18n/lingue';
import { formatData, formatNumero, momentoRelativo, type MomentoRelativo } from '@gestionale/core/i18n/formattazione';

export interface FormatiMappa {
  numero: (n: number) => string;
  /** «13 marzo 2026». */
  giorno: (iso: string | null | undefined) => string;
  /** «27/10/2026, 17:58». */
  dataOra: (iso: string | null | undefined) => string;
  momento: (iso: string | null | undefined) => MomentoRelativo | null;
}

export function useFormatiMappa(): FormatiMappa {
  const { i18n } = useTranslation('mappa');
  return useMemo(() => {
    const ctx = creaContestoLocale({ lingua: i18n.language, paese: 'IT', valuta: 'EUR', fusoOrario: 'Europe/Rome' });
    return {
      numero: (n) => formatNumero(n, ctx),
      giorno: (iso) => (iso ? formatData(iso, ctx, 'lunga') : ''),
      dataOra: (iso) => (iso ? formatData(iso, ctx, 'dataOra') : ''),
      momento: (iso) => (iso ? momentoRelativo(iso, ctx) : null),
    };
  }, [i18n.language]);
}
